import React from 'react';

interface ImageProps {
  src: string;
  width: number;
  height: number;
  alt: string;
  onClick?: () => void;
}

export const Image = ({ src, width, height, alt, onClick }: ImageProps) => (
  <img src={src} width={width} height={height} alt={alt} onClick={onClick} />
);
